
export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    block: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      options: {
        bgOpacity: 0.75,
      },
    };
  },
};
